import styled from 'styled-components';

// Components
import DropDownList from '../DropDownList';
import { AvatarContainer } from '../../buttons/UserButton/styles';
import { List } from '../DropDownList/styles';
import UserButton from '../../buttons/UserButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const ContainerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  svg {
    width: 1.1rem;
    height: 0.846rem;
  }
  svg > path {
    fill: ${({ theme }) => theme.colors.black};
  }
`;

export const ContainerDropDownTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const ButtonUser = styled(UserButton)`
  &${AvatarContainer} {
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
      theme.percentBaseResponsive}rem) {
      width: 3.9rem;
      height: 3.9rem;
      > p {
        font-size: ${({ theme }) => theme.fontSize.S};
      }
    }
  }
`;

export const ContainerUser = styled.div`
  line-height: 1.8rem;
`;

export const DropDownGroup = styled(DropDownList)`
  ${List} {
    width: 22.5rem;

    > li {
      font-size: ${({ theme }) => theme.fontSize.S};
    }

    @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
      theme.percentBaseResponsive}rem) {
      width: 18.4rem;

      > li {
        font-size: ${({ theme }) => theme.fontSize.XXS};
      }
    }
  }
`;
